var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Icon from '../../../Icon';
const IconPrinter = (_a) => {
    var { size, fill } = _a, commonProps = __rest(_a, ["size", "fill"]);
    const iconContent = {
        type: 'svg',
        content: (React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M18 11.3438C18.4657 11.3438 18.8438 10.9657 18.8438 10.5C18.8438 10.0343 18.4657 9.65625 18 9.65625C17.5343 9.65625 17.1562 10.0343 17.1562 10.5C17.1562 10.9657 17.5343 11.3438 18 11.3438Z", fill: "black" }),
            React.createElement("path", { d: "M7.5 3V6.75H5.0145C3.4875 6.75 2.25 7.97925 2.25 9.50025V15.9998C2.25 17.5208 3.4875 18.75 5.0145 18.75H7.5V21C7.5 21.414 7.836 21.75 8.25 21.75H15.75C16.164 21.75 16.5 21.414 16.5 21V18.75H18.9862C20.5125 18.75 21.75 17.5208 21.75 15.9998V9.50025C21.75 7.97925 20.5125 6.75 18.9862 6.75H16.5V3C16.5 2.586 16.164 2.25 15.75 2.25H8.25C7.836 2.25 7.5 2.586 7.5 3ZM7.5 17.25H5.0145C4.314 17.25 3.75 16.6897 3.75 15.9998V9.50025C3.75 8.81025 4.314 8.25 5.0145 8.25H18.9862C19.686 8.25 20.25 8.81025 20.25 9.50025V15.9998C20.25 16.6897 19.686 17.25 18.9862 17.25H16.5V15.75H18C18.414 15.75 18.75 15.414 18.75 15C18.75 14.586 18.414 14.25 18 14.25H6C5.586 14.25 5.25 14.586 5.25 15C5.25 15.414 5.586 15.75 6 15.75H7.5V17.25ZM9 20.25V15.75H15V20.25H9ZM9 6.75V3.75H15V6.75H9Z", fill: "black" }))),
        alt: 'Icon Printer',
    };
    return React.createElement(Icon, Object.assign({}, commonProps, { source: iconContent, size: size, fill: fill }));
};
export default IconPrinter;
//# sourceMappingURL=index.js.map